<template>
  <div
    @touchstart="phonetouchstart"
    @touchmove="phonetouchmove"
    @touchend="phonetouchend"
    @mousedown="move"
    @mouseover="setzoom"
    class="map-outline-border"
  >
    <!-- <iframe  src="../../map.svg" width="300" height="500"> 
    </iframe>-->
    <!-- <div style="">{{scaleend}},{{top}},{{left}}</div> -->
    <div
      :id="'zoomelement'+index"
      class="map-interior"
      :style="` width:${mapwidth}px;height:${mapheight}px;left:${left}px; top:${top}px;${newstyle};transform:scale(${nowzoom})`"
    >
    
      <slot style="width:100%;height:100%"></slot>
    </div>
    
    <div v-show="btn" class="zoom_btn_div">
      <!-- 缩放功能按钮组 -->
      <div class="btn_cursor" @click="resetzoom()" style="margin-bottom: 10px;">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35.1925">
        <g id="图层_2" data-name="图层 2"><g id="CONTENT" style="transform: scale(0.8);">
        <path class="mcls-1" d="M20.98,3.6a12.2912,12.2912,0,0,1,1.1274,16.083L34.4552,31.426c1.852,1.7617-1.47,5.0645-3.2266,3.2267L19.4569,22.2744A12.29,12.29,0,1,1,20.98,3.6ZM18.6059,5.974a8.9322,8.9322,0,1,0,0,12.6318A8.9312,8.9312,0,0,0,18.6059,5.974Z"/>
        <path class="mcls-2" d="M20.98,3.6a12.2916,12.2916,0,0,1,1.1277,16.083L34.4552,31.426A1.9809,1.9809,0,0,1,34.29,34.29L18.6063,18.6058A8.9325,8.9325,0,0,0,5.9741,5.9732L3.6,3.5992A12.29,12.29,0,0,1,20.98,3.6Z"/>
        </g></g>
        </svg>
      </div>
      <div style="margin-bottom: 4px;" class="btn_cursor" @click="addzoom()">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.6268 36.6268">
        <g id="图层_2" data-name="图层 2">
        <g id="CONTENT"><circle class="mcls-1" cx="18.3134" cy="18.3134" r="17.8134"/>
        <path d="M16.0458,20.602H9.3269V16.0458h6.7189V9.3269H20.602v6.7189H27.3V20.602H20.602V27.3H16.0458Z"/>
        </g>
        </g>
        </svg>
      </div>
      <div class="btn_cursor" @click="subtractzoom()">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.6268 36.6268">
        <g id="图层_2" data-name="图层 2">
        <g id="CONTENT">
        <circle class="mcls-1" cx="18.3134" cy="18.3134" r="17.8134"/>
        <path d="M25.3682,20.5915h-14.11V16.0353h14.11Z"/>
        </g>
        </g>
        </svg>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      scaleend:1,
      p_x: 0, // 记录起点
      p_y: 0, // 记录起点
      start: [], // 缩放起点记录
      nowzoom:null, //元素放大的倍数
      mapwidth: "100%", //内容宽
      mapheight: "100%", //内容高
      top: 0, //地图移动偏量高
      left: 0, //地图移动偏量宽
      map_ele: null,
      movetype:true
    };
  },

  props: ["index", "btn", "w", "h", "x", "y", "zoomsize", "newstyle"],
  mounted() {
    this.get_map_element();
    this.mapwidth = this.w+"px";
    this.mapheight = this.h+"px";
    this.nowzoom = this.zoomsize
    let map = document.getElementsByClassName("map-outline-border")[0];
    let new_w = map.offsetWidth; //获取元素宽度
    let new_h = map.offsetHeight; //获取元素高度
    this.top = this.y;
    this.left = (new_w - this.mapwidth) / 2;
    // console.log(this.left,this.zoomsize);
  },
  methods: {
    resetzoom() {
      this.top = 0;
      this.left = 0;
      this.nowzoom = 1;
      this.set_map_zoom();
    },
    subtractzoom() {
      this.nowzoom -= 0.2;
      this.set_map_zoom();
    },
    addzoom() {
      this.nowzoom += 0.2;
      this.set_map_zoom();
    },
    get_map_element() {
      let op = document.getElementById(`zoomelement${this.index}`);
      this.map_ele = op;
      return op;
    },
    set_map_zoom() {
      // this.top = 0
      // this.left = 0
    //   this.zoomsize = this.zoomsize > 0.3 ? this.zoomsize : 0.3;
    //   this.zoomsize = this.zoomsize < 4 ? this.zoomsize : 2;
      // console.log(this.zoomsize)
      this.map_ele.style.transform = "scale(" + this.nowzoom + ")";
      
    },
    setzoom(e) {
      document.onmousewheel = (e) => {
        // 鼠标滚轮事件
        // 获取当前元素放大后的事件参数
        // console.log("鼠标缩放操作===>>>", e.wheelDelta,this.nowzoom);
        if (e.wheelDelta < 0 ) {
          if (this.nowzoom <= 1) return
          console.log("-");
          var nowsize = this.zoomsize -0.1;
          this.nowzoom -= 0.1
          this.$emit("setzoomsize",this.nowzoom)
          this.set_map_zoom();

        } else {
          if (this.nowzoom >= 5) return
          console.log("+");
          this.nowzoom += 0.1;
          this.$emit("setzoomsize",this.nowzoom)
          this.set_map_zoom();
        }
            // this.elementT_L(op);
        // console.log("sss",this.zoomsize)
        // let op = this.get_map_element();
        // let ele_w = op.offsetWidth; //获取元素宽度
        // let ele_h = op.offsetHeight; //获取元素宽度
        // var map_ele = op.getBoundingClientRect();
        // let newtop = map_ele.top;
        // let newleft = map_ele.left;
        // this.top = newtop;
        // this.left = newleft;

        // console.log("=====>>>", map_ele, newtop, newleft, e.clientX, e.clientY);
      };
    },
    move(e) {
          

      let firstTime, lastTime;
      firstTime = new Date().getTime();
      // @mousedown="move"
      // let op = e.target; //获取目标元素
      let op = this.get_map_element();
      // let ele_w = op.offsetWidth; //获取元素宽度
      // let ele_h = op.offsetHeight; //获取元素宽度
      // var map_ele = op.getBoundingClientRect();
      let newtop = op.offsetTop;
      let newleft = op.offsetLeft;
      // let new_w = op.offsetWidth; //获取元素宽度
      // let new_h = op.offsetHeight; //获取元素高度
      // let newtop = map_ele.top;
      // let newleft = map_ele.left;
      // this.mapwidth = map_ele.width; //获取元素宽度
      // this.mapheight = map_ele.height; //获取元素高度
      // console.log("=====>>>", map_ele, newtop, newleft, e.clientX, e.clientY);
      //算出鼠标相对元素的位置,
      let x = e.clientX - newleft;
      let y = e.clientY - newtop;

      // console.log("元素位置===", newleft, newtop);
      // console.log("鼠标位置===", e.clientX, e.clientY);
      // console.log("元素实际位置2===", op.offsetLeft, op.offsetTop);
      // console.log("鼠标相对元素位置===", x, y);
      document.onmousemove = (e) => {
        lastTime = new Date().getTime();
        if (lastTime - firstTime > 100) {
          e.stopPropagation();
          let left = e.clientX - x;
          let top = e.clientY - y;
          //绑定元素位置到positionX和positionY上面
          // console.log("元素跟随鼠标移动的位置===", left, top);
          this.top = top; // > 0 ? 0 : top; 限制拖动范围
          this.left = left; // > 0 ? 0 : left; 限制拖动范围
        }
      };

      document.onmouseup = (e) => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
    getDistance(p1, p2) {
      var x = p2.pageX - p1.pageX,
        y = p2.pageY - p1.pageY;
      return Math.sqrt(x * x + y * y);
    },
    phonetouchmove(e) {
      let op = document.getElementById(`zoomelement${this.index}`);
      let eleW = op.offsetWidth; //获取元素宽度
      let eleH = op.offsetHeight;
        // console.log(this.movetype )
      if (e.touches.length == 1 ) {


            let left = e.targetTouches[0].clientX - this.p_x;
            let top = e.targetTouches[0].clientY - this.p_y;
            // this.Drag(op, top, left); //拖动元素
            this.top = top;
            this.left = left;
        // console.log("滑动---",e.targetTouches[0],op.offsetLeft);
        //算出鼠标相对元素的位置

        // this.start = e.touches; //得到第一组两个点
      }
    //   if (e.touches.length == 2) {
    //     var now = e.touches;
    //     var scale =
    //       this.getDistance(now[0], now[1]) /
    //       this.getDistance(this.start[0], this.start[1]);
    //     // console.log("获得缩放比例---", scale);
    //     console.log("比例取整---", scale);

    //     if(scale>this.scaleend && this.zoomsize < 3){
    //         this.zoomsize+=0.02
    //         this.scaleend = scale
    //     }
    //     if(scale<this.scaleend && this.zoomsize > 0.5){
    //         this.zoomsize-=0.02
    //         this.scaleend = scale
    //     }
    //     // this.zoomsize = scale.toFixed(2);    
    //     this.set_map_zoom();

    //   }
    },
    phonetouchstart(e) {
      let op = document.getElementById(`zoomelement${this.index}`);
      console.log("手指按下开始执行---", e.touches);
      let htmls = document.querySelector("html");
      htmls.style = "overflow:hidden;height:100%;";
      if (e.touches.length == 2) {
        //判断是否有两个点在屏幕上
        // console.log("双指---");
        this.start = e.touches; //得到第一组两个点

      }
      if (e.touches.length == 1) {
        // console.log("单指---");
        this.p_x = e.targetTouches[0].clientX - op.offsetLeft;
        this.p_y = e.targetTouches[0].clientY - op.offsetTop;
        console.log(this.x, this.y);
      }
    },
    phonetouchend(e) {
      console.log("结束操作---");

      let htmls = document.querySelector("html");
      htmls.style = "overflow: visible;";
    },
  },
  	destroyed(){
		
	},
};
</script>
<style lang="less">
html,
body {
  overflow: hidden;
}
.map-outline-border {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  /* background: white !important; */
}
.map-interior {
  position: absolute;
  display: flex;
  -webkit-user-drag: none;
  user-select: none;
  cursor: pointer;
      width: 100%;
    height: 100%;

  /* background: tomato; */
  /* left: 0px;
  top: 0px; */
}
.zoom_btn_div {
  width: auto;
  bottom: 5%;
  right: 15px;
  position: absolute;
  display: grid;
}
.zoom_btn_div div {
  color: #000;
  line-height: 10px;
  /* margin: 2px; */
  width: 25px;
  height: 25px;
  background: rgb(255, 255, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 23px;
    svg{
      position: relative;
      top: auto;
      left: auto;
      width: 100%;
      height: 100%;
    }
}

.btn_cursor {
  box-shadow: 0px 0px 2px rgb(204, 203, 203);
  line-height: 30px;
  /* background: #000; */
  /* color: white; */
  border-radius: 25px;
}

.btn_cursor:hover {
  cursor: pointer;
  -webkit-touch-callout: none;
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
}
.mcls-1{fill:none;stroke:#000;stroke-miterlimit:10;}
.mcls-1,.mcls-2{fill-rule:evenodd;}
.mcls-2{fill:#0c0c0c;}
</style>